/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Deployservicev3Creative } from '../models/Deployservicev3Creative';
import { V3RTBCampaign } from '../models/V3RTBCampaign';
import { V3RTBCreativeMap } from '../models/V3RTBCreativeMap';
import { V3RTBOrderLine } from '../models/V3RTBOrderLine';
import { V3Segment } from '../models/V3Segment';
import { HttpFile } from '../http/http';

/**
* The configuration for RTB deployment destinations
*/
export class V3RTBConfiguration {
    /**
    * ID of the Order Line.
    */
    'orderLineId'?: string;
    /**
    * ID of the Organization.
    */
    'advertiserId'?: string;
    'rtbOrderLine'?: V3RTBOrderLine;
    /**
    * Creatives that will be deployed.
    */
    'creatives'?: Array<Deployservicev3Creative>;
    /**
    * Segments that will be deployed.
    */
    'segments'?: Array<V3Segment>;
    'rtbCampaign'?: V3RTBCampaign;
    'creativeMap'?: V3RTBCreativeMap;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "advertiserId",
            "baseName": "advertiser_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "rtbOrderLine",
            "baseName": "rtb_order_line",
            "type": "V3RTBOrderLine",
            "format": ""
        },
        {
            "name": "creatives",
            "baseName": "creatives",
            "type": "Array<Deployservicev3Creative>",
            "format": ""
        },
        {
            "name": "segments",
            "baseName": "segments",
            "type": "Array<V3Segment>",
            "format": ""
        },
        {
            "name": "rtbCampaign",
            "baseName": "rtb_campaign",
            "type": "V3RTBCampaign",
            "format": ""
        },
        {
            "name": "creativeMap",
            "baseName": "creative_map",
            "type": "V3RTBCreativeMap",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3RTBConfiguration.attributeTypeMap;
    }

    public constructor() {
    }
}

